<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div>
    <br />
    <h2>
      Projetos
      <button
        data-toggle="modal"
        data-target="#new-project-modal"
        style="margin-left: 15px"
        type="button"
        class="btn btn-primary"
        @click="clearProject"
      >
        <i class="fas fa-plus" style="margin-right: 5px"></i>
        Novo projeto
      </button>
    </h2>
    <br />
    <!-- FILTROS -->
    <div class="row" style="width: 100%">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <form v-on:submit.prevent="searchProjects()">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="input-group mb-3">
                      <input class="form-control" id="id" v-model="filtro" placeholder="Buscar project" />

                      <span class="input-group-append">
                        <button @click="searchProjects()" style="border-radius: 2px" type="submit" class="btn btn-info">
                          <i class="fas fa-search" style="margin-right: 5px"></i>
                          Buscar
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 0px 0px 10px 0px; color: red" v-if="searchBuscado">Exibindo resultados para "{{ filtro }}"</div>

    <!-- PROJECTS -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Project</h3>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Nome</th>
              <th>Código</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(project, index) in projects" :key="project" @contextmenu.prevent="onRightClick($event, project)" @click="hideMenu()">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Nome">{{ project.name }}</td>
              <td data-label="Código">{{ project.code }}</td>
              <td data-label="Editar">
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>
                  <a @click="selectProject(project)" data-toggle="modal" data-target="#new-project-modal" class="dropdown-item">
                    <i class="fa-solid fa-pen"></i>
                    &nbsp;&nbsp; Editar
                  </a>

                  <div class="dropdown-divider"></div>
                  <a @click="deletar(project)" class="dropdown-item">
                    <i class="fa-solid fa-bars"></i>
                    &nbsp;&nbsp; Deletar
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div
          id="newMenu"
          style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
          class="dropdown-menu-lg dropdown-menu-right"
        >
          <div class="dropdown-divider"></div>
          <a
            style="cursor: pointer"
            @click="selectProject(selected_project)"
            class="dropdown-item"
            data-toggle="modal"
            data-target="#new-project-modal"
          >
            <i class="fa-solid fa-pen"></i>
            &nbsp;&nbsp; Editar
          </a>

          <div class="dropdown-divider"></div>
          <a style="cursor: pointer" @click="deletar(selected_project)" class="dropdown-item">
            <i class="fa-solid fa-bars"></i>
            &nbsp;&nbsp; Deletar
          </a>
        </div>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + projects.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="1">1</option>
          <option :value="2">2</option>
          <option :value="7">7</option>
          <option :value="15">15</option>
          <option :value="25">25</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
        </ul>
      </div>
    </div>

    <!-- MODAL -->
    <div
      class="modal fade"
      id="new-project-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>{{ titulo_modal }}</h4>
              <br />
              <div class="card card-primary">
                <div class="card-header">
                  <h3 class="card-title" style="color: white"></h3>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- CODE -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="name">Nome</label>
                        <input class="form-control" id="code" v-model="formData.name" />
                      </div>
                    </div>

                    <!-- CODE -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="code">Código</label>
                        <input class="form-control" id="code" v-model="formData.code" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <button data-toggle="modal" class="btn btn-success" @click="validate">{{ titulo_btn }}</button>
                  <button style="margin-left: 15px" data-toggle="modal" id="cancelar" data-target="#new-project-modal" class="btn btn-danger">
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

import useVueLidate from "@vuelidate/core";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  props: ["estados", "comitentes", "processos"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      projects: [],
      acao: "",
      titulo_btn: "",
      titulo_modal: "",
      selected_project: "",
    };
  },

  setup() {
    const formData = reactive({
      code: "",
      name: "",
    });

    const rules = computed(() => {
      return {
        code: { required },
        name: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log(this.docs_tipo_usuario);

    this.searchProjects();
  },

  methods: {
    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, project) {
      this.selected_project = project;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 250;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    clearProject() {
      this.titulo_btn = "Cadastrar";
      this.titulo_modal = "Novo projeto";
      this.acao = "store";

      this.formData.code = "";
      this.formData.name = "";
    },

    selectProject(project) {
      console.log("Selecionado");
      console.log(project);

      this.titulo_btn = "Gravar";
      this.titulo_modal = "Editar projeto ID " + project.id;
      this.acao = "update";

      this.selected_project = project;
      this.formData.code = project.code;
      this.formData.name = project.name;
    },

    async validate() {
      const result = await this.v$.$validate();

      if (result) {
        if (this.acao == "store") {
          this.store();
        } else {
          this.update();
        }
      }
    },

    store() {
      this.isLoading = true;

      let data = {
        name: this.formData.name,
        code: this.formData.code,
      };

      console.log("Cadastrando");
      console.log(data);
      axios
        .post(`/admin/project/store`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Projeto cadastrado", "/admin/projects");
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    update() {
      this.isLoading = true;

      let data = {
        project_id: this.selected_project.id,
        name: this.formData.name,
        code: this.formData.code,
      };

      console.log("Atualizando");
      console.log(data);

      axios
        .post(`/admin/project/update`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Projeto atualizado", "/admin/projects");
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onChange(e) {
      this.formData.upload_files = e.target.files[0];
    },

    visualizar(leilao) {
      this.leilao_selecionado = leilao;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(leilao) {
      return "/admin/leilao/" + leilao.id;
    },

    show(leilao) {
      this.leilao_selecionado = leilao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.searchProjects();
      }
    },

    searchProjects() {
      this.isLoading = true;

      let data = {
        id: this.id,
        inicio: this.inicio,
        filtro: this.filtro,
        tamanho: this.qtd_por_pagina,
      };

      console.log(data);

      if (this.filtro && this.filtro != "") {
        this.searchBuscado = true;
      } else {
        this.searchBuscado = false;
      }

      axios
        .post(`/admin/project/search`, data)
        .then((response) => {
          this.isLoading = false;
          this.projects = response.data.projects;
          this.total = response.data.total;

          console.log("projects");
          console.log(this.projects);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.caminho_foto;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.searchProjects();
    },

    deletar(obra) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar a obra<br/><b>" + obra.titulo + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              obra_id: obra.id,
            };

            axios
              .post(`/admin/obra/delete`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Obra deletada", "/admin");
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.current-page {
  background-color: #428bca !important;
  color: white;
}

.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
